import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { TaskRelationCollection } from '../index'

export const setupTaskRelationReplication = (
  collection: TaskRelationCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'taskrelations',
    displayName: 'TaskRelation',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      sourceTaskId: doc.sourceWorkItemId || doc.sourceTaskId, // Backend sends sourceWorkItemId
      sourceProjectId: doc.sourceProjectId,
      targetTaskId: doc.targetWorkItemId || doc.targetTaskId, // Backend sends targetWorkItemId
      targetProjectId: doc.targetProjectId,
      relationType: doc.relationType,
      isDeleted: doc.isDeleted || false,
      sourceTaskName: doc.sourceWorkItemName || doc.sourceTaskName,
      sourceIdentifier: doc.sourceIdentifier,
      targetTaskName: doc.targetWorkItemName || doc.targetTaskName,
      targetIdentifier: doc.targetIdentifier,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      sourceWorkItemId: state.sourceTaskId, // Frontend uses sourceTaskId, backend expects sourceWorkItemId
      sourceProjectId: state.sourceProjectId,
      targetWorkItemId: state.targetTaskId, // Frontend uses targetTaskId, backend expects targetWorkItemId
      targetProjectId: state.targetProjectId,
      relationType: state.relationType,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
